import type { StoreItem } from './StoreLocator.types';
import * as Styled from './StoreLocator.styled';

interface StoreDetailsProps {
  store: StoreItem;
}

const days = [
  ['Monday', 'monday'],
  ['Tuesday', 'tuesday'],
  ['Wednesday', 'wednesday'],
  ['Thursday', 'thursday'],
  ['Friday', 'friday'],
  ['Saturday', 'saturday'],
  ['Sunday', 'sunday'],
] as const;

export const StoreDetails = ({ store }: StoreDetailsProps) => (
  <Styled.DetailsPanel>
    <Styled.StoreName>{store.storeName}</Styled.StoreName>

    <Styled.AddressBlock>
      {store.address.street && <span>{store.address.street}</span>}
      {store.address.town && <span>{store.address.town}</span>}
      {store.address.otherDetails && <span>{store.address.otherDetails}</span>}
    </Styled.AddressBlock>

    <div>
      <Styled.DetailRow>
        <Styled.DetailLabel>Telephone:</Styled.DetailLabel>
        <Styled.DetailValue>{store.telephone}</Styled.DetailValue>
      </Styled.DetailRow>
      <Styled.DetailRow>
        <Styled.DetailLabel>Email:</Styled.DetailLabel>
        <Styled.DetailValue>{store.email}</Styled.DetailValue>
      </Styled.DetailRow>
    </div>

    <div>
      <Styled.SectionHeading>Opening Times</Styled.SectionHeading>
      {days.map(([label, key]) => (
        <Styled.DetailRow key={key}>
          <Styled.DetailLabel>{label}:</Styled.DetailLabel>
          <Styled.DetailValue>{store[key]}</Styled.DetailValue>
        </Styled.DetailRow>
      ))}
    </div>

    <div>
      <Styled.SectionHeading>GPS Co-ordinates</Styled.SectionHeading>
      <Styled.DetailRow>
        <Styled.DetailLabel>Latitude:</Styled.DetailLabel>
        <Styled.DetailValue>{store.latitude}</Styled.DetailValue>
      </Styled.DetailRow>
      <Styled.DetailRow>
        <Styled.DetailLabel>Longitude:</Styled.DetailLabel>
        <Styled.DetailValue>{store.longitude}</Styled.DetailValue>
      </Styled.DetailRow>
    </div>
  </Styled.DetailsPanel>
);
